import { css } from '@emotion/core';
import { variables, tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
var colour = variables.colour;
export var text = colour.neutral700;
export var textDark = colour.neutral800;
export var textLight = colour.neutral500;
export var heading = colour.neutral800;
export var globalStyles = /*#__PURE__*/css(":focus-visible{outline-color:", colors.neutral.trim.pressed, ";}");